import React, { useMemo, useState } from "react";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import { createTheme, ThemeProvider, useTheme, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Snackbar, Alert } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from 'moment';

function RemitosTable({ 
    rowSelection, 
    setRowSelection,
    remitos = []
}) {
    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        showColumnFilters: false,
        columnVisibility: { 
            id_remito: false, 
        },
        pagination: {
            pageSize: 5,
            pageIndex: 0,
        },
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            pt: 1,
        },
    };
console.log("remitos",remitos);

    const columns = useMemo(
        () => [
            {   
                accessorKey: "id_remito",
                header: "#",
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 5,
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                        maxWidth: 5,
                    },
                },
            },
            {
                accessorKey: "nro",
                header: "Nro Remito",
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 5,
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                        maxWidth: 5,
                    },
                },
            },
            {
                accessorKey: "fecha",
                header: "Fecha",
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 5,
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? moment(cell.getValue()).format("DD/MM/YYYY")
                        : "",
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                        maxWidth: 5,
                    },
                },
            },
            {
                accessorKey: "razon_social",
                header: "Cliente",
                enableColumnActions: false,
                maxSize: 5,
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                    },
                },
            },
            {
                accessorKey: "sucursal",
                header: "Sucursal Remite",
                enableColumnActions: false,
                maxSize: 5,
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                    },
                },
            },
            {
                accessorKey: "estado",
                header: "Estado",
                enableColumnActions: false,
                maxSize: 5,
                muiTableBodyCellProps: {
                    sx: {
                        color: "black",
                    },
                },
            },
        ],
        []
    );

    const globalTheme = useTheme();
    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary,
                    info: {
                        main: "rgb(255,122,0)",
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000",
                    },
                },
                typography: {
                    button: {
                        textTransform: "none",
                        fontSize: "1rem",
                    },
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem",
                            },
                        },
                    },
                },
            }),
        [globalTheme]
    );

    const customLocalization = {
        ...MRT_Localization_ES,
        expandAll: false,
        expand: <ExpandMoreIcon />,
    };

    const [avisoProvincia, setAvisoProvincia] = useState(false);

    const provinciaSeleccionada = useMemo(() => {
        const keysSeleccionadas = Object.keys(rowSelection).filter(
            (key) => rowSelection[key]
        );
        if (keysSeleccionadas.length === 0) return null;
        const primerSeleccionado = remitos[parseInt(keysSeleccionadas[0])];
        return primerSeleccionado?.id_provincia ?? null;
    }, [rowSelection, remitos]);

    const enableRowSel = (row) => {
        if (provinciaSeleccionada == null) return true;
        const idProvinciaFila = row.original.id_provincia;
        if (idProvinciaFila == null) return true;
        return idProvinciaFila === provinciaSeleccionada;
    };

    const handleRowClick = (row) => (event) => {
        if (!row.getIsSelected() && !enableRowSel(row)) {
            setAvisoProvincia(true);
            return;
        }
        row.getToggleSelectedHandler()(event);
    };

    return (
        <>
            {remitos?.length > 0 && (
                <ThemeProvider theme={tableTheme}>
                    <MaterialReactTable
                        renderDetailPanel={({ row }) => {
                            const items = typeof row.original.items === 'string'
                                ? JSON.parse(row.original.items)
                                : (row.original.items || []);

                            return (
                                <Box sx={{ p: 2, bgcolor: "#f8fafc" }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                                        Detalle de ítems del remito #{row.original.nro}:
                                    </Typography>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><b>Producto</b></TableCell>
                                                <TableCell align="right"><b>Cantidad</b></TableCell>
                                                <TableCell><b>Unidad</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {items.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item.producto}</TableCell>
                                                    <TableCell align="right">{item.cantidad}</TableCell>
                                                    <TableCell>{item.nombre_um}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            );
                        }}

                        enableMultiRowSelection
                        enablePagination={false}
                        muiTableContainerProps={{ sx: { maxHeight: "300px" } }}
                        columns={columns}
                        data={remitos}
                        enableTopToolbar={false}
                        muiTableHeadCellProps={tableHeadCellProps}
                        initialState={initialState}
                        localization={customLocalization}
                        // getRowId={(row) => row.id_remito} 
                        enableRowSelection={enableRowSel}
                        // enableRowSelection={(row) => enableRowSel(row)}
                        onRowSelectionChange={setRowSelection}
                        state={{ rowSelection }} 
                        enableSelectAll={false}
                        muiTableBodyRowProps={({ row }) => ({
                            onClick: handleRowClick(row),
                            sx: { cursor: "pointer" },
                        })}
                        enableStickyHeader
                        muiBottomToolbarProps={{
                            sx: {
                                minHeight: "20px",
                                maxHeight: "20px",
                            },
                        }}
                    />
                </ThemeProvider>
            )}
            <Snackbar
                open={avisoProvincia}
                autoHideDuration={6000}
                onClose={() => setAvisoProvincia(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setAvisoProvincia(false)}
                    severity="warning"
                    variant="filled"
                >
                    No se pueden agrupar remitos de provincias distintas.
                </Alert>
            </Snackbar>
        </>
    );
}

export default RemitosTable;